import Image from 'next/image';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import emptyStateIllustration from '@/assets/appointments/empty-state-illustration.svg?url';
import emptyStateMagnifier from '@/assets/appointments/empty-state-magnifier.svg?url';
import { Button } from '@/components/ui/button/button.component';
import { Link } from '@/components/ui/link/link.component';
import { Typography } from '@/components/ui/typography/typography.component';

export function AppointmentsEmptyState() {
  return (
    <div
      data-testid={DataTestIdEnum.APPOINTMENTS_EMPTY_STATE}
      className="flex flex-col items-center gap-4 w-full"
    >
      <div className="relative h-[154px] w-[191px]">
        <Image
          src={emptyStateIllustration}
          alt=""
          width={151}
          height={132}
          draggable={false}
          className="absolute left-5 top-0"
        />
        <Image
          src={emptyStateMagnifier}
          alt=""
          width={59}
          height={60}
          draggable={false}
          className="absolute left-[69%] top-[61%]"
        />
      </div>
      <div className="flex flex-col gap-2 text-center w-full">
        <Typography className="text-lg font-bold text-gray-900">
          Agende seu atendimento
        </Typography>
        <Typography className="text-base text-gray-700">
          Encontre o atendimento ideal e faça seu agendamento agora mesmo.
        </Typography>
      </div>
      <Button asChild color="primary" className="w-full md:max-w-75">
        <Link
          href="/"
          data-testid={DataTestIdEnum.APPOINTMENTS_EMPTY_STATE_BUTTON}
        >
          Agendar
        </Link>
      </Button>
    </div>
  );
}
